import type { ReactNode } from "react"
import { useEffect } from "react"
import {
  SWRConfig,
  useSWRConfig,
} from "swr"
import { LocalStorageSWRCache } from "./localStorageSWRCacheProvider"
import { useAuthContext } from "src/contexts/AuthContext"

const cache = new LocalStorageSWRCache()

interface Props {
  children: ReactNode;
}

function SWRClearer() {
  const { mutate } = useSWRConfig()
  const { authCookie } = useAuthContext()

  useEffect(
    () => {
      if (!authCookie?.access_token) {
        // clear all cached swr data on log out
        void mutate(
          () => true, // which cache keys are updated
          undefined, // update cache data to `undefined`
          { revalidate: true }, // refetch data if possible
        )
      }
    },
    [
      authCookie,
      mutate,
    ],
  )

  return null
}

// a provider so that the swr hooks can use the same config with local storage cache
export function SWRConfigProvider(props: Props) {
  return (
    <SWRConfig value={{ provider: () => cache }}>
      <SWRClearer />
      {props.children}
    </SWRConfig>
  )
}
